/**
 * @Author: v_jppjpeng
 * @Date: 2025-06-20 16:26:26
 * @Explain: 二次确认邮件配置
 */
import type { HttpResponse } from '../data';
import type {
  ReportFilterParams,
  ReportResponse,
  ApiItemResponse,
  formItemResponse,
} from '../doubleOptIn/data.d';
import http from '../http';
import httpV2 from '../http-v2';
const MODEL = '/web_hook';
const MODEL2 = '/opt_in';
const SIGNUP_FORM_MODEL = '/signup_form';
const OPEN_API_MODEL = '/open_api';

export default {
  // 详情
  getDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/details`, data, {
      params: { switchReqToUnderline: true },
    });
  },

  // 获取Double Opt-in来源列表（新增接口，待后端确认endpoint）
  getSourceList(data: Record<any, any>) {
    return httpV2.post(`${MODEL2}/source-list`, data, {
      params: { switchReqToUnderline: true },
    });
  },

  getAllForm(data: Record<any, any>): Promise<HttpResponse<formItemResponse>> {
    return httpV2.post(`${SIGNUP_FORM_MODEL}/get_all`, data, {
      params: { switchReqToUnderline: true },
    });
  },

  getAllApi(data: Record<any, any>): Promise<HttpResponse<ApiItemResponse>> {
    return httpV2.post(`${OPEN_API_MODEL}/get_all`, data, {
      params: { switchReqToUnderline: true },
    });
  },

  // 获取报表指标数据（统一接口，包含指标、Performance图表和Non-delivery Analysis数据）
  getReportMetrics(
    data: ReportFilterParams,
  ): Promise<HttpResponse<ReportResponse>> {
    return httpV2.post(`${MODEL2}/report`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
